import { CSSProperties, ReactNode } from "react";
import Flex from "common/Boxes/Flex";
import styled from "styled-components";

interface SquareSwitchProps {
  style?: CSSProperties;
  items: SwitchItem[];
  selectedKey: string;
  onChange: (selectedKey: string) => void;
}

const SquareSwitch = ({
  style,
  items,
  selectedKey,
  onChange,
}: SquareSwitchProps) => {
  return (
    <Background style={style}>
      {items.map((item) => (
        <IconBg
          key={item.key}
          $selected={item.key === selectedKey}
          onClick={() => onChange(item.key)}
        >
          <IconWrapper>{item.label}</IconWrapper>
        </IconBg>
      ))}
    </Background>
  );
};

export default SquareSwitch;

interface SwitchItem {
  label: ReactNode;
  key: string;
}

const Background = styled(Flex)`
  border-radius: 6px;
  padding: 4px;
  background: ${(p) => p.theme.colors.lightBlue};
  cursor: pointer;
  ${(p) =>
    p.theme.isNewLook &&
    `
    border-radius: ${p.theme.radii.control}px;
    padding: 2px;
    background: ${p.theme.colors.cardLightBgColor};
    box-shadow: inset 0 0 0 1px ${p.theme.colors.lightestBorderGrey};
  `}
`;
const IconBg = styled.div<{ $selected?: boolean }>`
  border-radius: 6px;
  padding: 5px 7px;
  fill: ${(p) =>
    p.$selected ? p.theme.colors.layoutBgColor : p.theme.colors.primaryBlue};
  color: ${(p) =>
    p.$selected ? p.theme.colors.layoutBgColor : p.theme.colors.primaryBlue};
  background: ${(p) =>
    p.$selected ? p.theme.colors.primaryBlue : "transparent"};
  transition: background-color 0.25s linear;
  ${(p) =>
    p.theme.isNewLook &&
    `
    border-radius: ${6}px;
    padding: 4px 8px;
    font-weight: ${p.theme.typography.fontWeights.SEMI_BOLD};
    fill: ${p.$selected ? p.theme.colors.titleColor : p.theme.colors.secondaryText};
    color: ${p.$selected ? p.theme.colors.titleColor : p.theme.colors.secondaryText};
    background: ${p.$selected ? p.theme.colors.cardBgColor : "transparent"};
    box-shadow: ${
      p.$selected
        ? `0 1px 2px rgba(16, 24, 40, 0.08), 0 0 0 1px ${p.theme.colors.cardBorderColor}`
        : "none"
    };
  `}
`;
const IconWrapper = styled(Flex)`
  height: 16px;
`;
